import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import page404 from "@src/assets/page404.svg";
import Container from "@src/components/shared/Container";
import { Button } from "@src/components/ui/button";
import useZustandStore from "@src/helpers/zustand";
import { getErrorUrl } from "@src/utils/consts";

function Page404() {
  const { i18n } = useTranslation();
  const { clearData } = useZustandStore((state) => state);

  useEffect(() => {
    clearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { t } = useTranslation();

  return (
    <Container className="max-md:!mt-32">
      <img
        alt="logo"
        className="relative top-1 h-auto max-h-[132px] mx-auto mb-0 w-3/4 mt-32 sm:mt-20"
        src={page404}
      />
      <h1 className="rounded-full p-5 border-2 border-solid border-white sm:border-none text-center font-bold text-lg relative max-sm:-top-4 max-sm:backdrop-blur-[13px]">
        {t("404")}
      </h1>
      <div
        className="w-full self-end rounded-[6px] bg-white py-8
       max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
      >
        <a className="w-full" href={getErrorUrl(i18n.language)}>
          <Button className="w-full">{t("back")}</Button>
        </a>
      </div>
      {/* <Button
        className="w-full"
        onClick={() => {
          throw new Error("Test Sentry error - button click");
        }} 
      >
        Trigger Test Error
      </Button> */}
    </Container>
  );
}

export default Page404;
